import React from "react";

export const STATES = {
  review:      { label: "Needs review",       short: "Review",       cls: "border-red-400/50 bg-red-500/15 text-red-200", who: "Staff" },
  overdue:     { label: "Overdue homework",   short: "Overdue",      cls: "border-red-400/50 bg-red-500/15 text-red-200", who: "Chase resident" },
  waiting:     { label: "Waiting on resident", short: "Waiting",     cls: "border-amber-400/50 bg-amber-400/10 text-amber-200", who: "Follow up" },
  assign_next: { label: "Assign next week",   short: "Assign next",  cls: "border-sky-400/50 bg-sky-400/10 text-sky-200", who: "Staff" },
  not_started: { label: "Not started",        short: "Not started",  cls: "border-white/15 bg-white/[0.03] text-nex-muted", who: "Staff" },
  up_to_date:  { label: "Up to date",         short: "Up to date",   cls: "border-emerald-400/50 bg-emerald-400/10 text-emerald-200", who: "—" },
};

export const QUEUES = ["review", "assign_next", "waiting", "overdue", "not_started", "touchpoint_due"];

export function QueueButtons({ counts, active, onPick }) {
  return (
    <div data-testid="pillar-board-queues" className="grid grid-cols-3 lg:grid-cols-6 gap-2">
      {QUEUES.map((q) => {
        const st = STATES[q] || { label: "Weekly review due", cls: "border-violet-400/50 bg-violet-400/10 text-violet-200", who: "Staff" };
        const on = active === q;
        return (
          <button key={q} type="button" onClick={() => onPick(on ? null : q)} data-testid={`pillar-board-queue-${q}`} aria-pressed={on}
            className={`text-left px-3 py-2 border rounded-sm transition-[background-color,border-color] ${st.cls} ${on ? "ring-1 ring-nex-gold" : "opacity-90 hover:opacity-100"}`}>
            <div className="font-mono text-[9px] tracking-[0.18em] uppercase">{st.label}</div>
            <div className="flex items-baseline gap-2">
              <span data-testid={`pillar-board-queue-${q}-count`} className="text-xl font-semibold">{counts[q] ?? 0}</span>
              <span className="text-[10px] opacity-70">{st.who}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
}

export function BoardCell({ c, rid, dim, onOpen }) {
  const st = STATES[c.state];
  return (
    <button type="button" onClick={onOpen} data-testid={`pillar-board-cell-${rid}-${c.pillar_id}`} title={c.lead ? `Lead: ${c.lead.name}` : "No lead assigned"}
      className={`w-full text-left px-2 py-1.5 border rounded-sm transition-opacity hover:ring-1 hover:ring-nex-gold/60 ${st.cls} ${dim ? "opacity-30" : ""}`}>
      <div className="font-mono text-[9px] tracking-[0.14em] uppercase">{st.short}{c.days != null ? ` · ${c.days}d` : ""}</div>
      <div className="text-[11px] text-nex-silver/90">
        {c.last_week ? `Wk ${c.last_week}` : "Wk 0"}{c.behind ? <span className="text-nex-muted"> · {c.behind} behind</span> : null}
        {c.open_week ? <span className="text-nex-muted"> · open wk {c.open_week}</span> : null}
      </div>
    </button>
  );
}
